import { Link, useLocation } from "react-router-dom";
import { Home, Store, ShoppingBag, Newspaper } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const BottomNav = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();

  const itemCls = (active) =>
    `flex flex-col items-center gap-0.5 text-[11px] font-semibold transition-colors ${active ? "text-coral" : "text-muted-moss"}`;

  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 inset-x-0 z-40 bg-cream/95 backdrop-blur-md border-t border-[#E3E7E2] px-6 py-2 flex items-center justify-between soft-shadow md:hidden">
      <Link to="/" data-testid="bottomnav-home" className={itemCls(pathname === "/")}>
        <Home className="w-5 h-5" /> Inicio
      </Link>
      <Link to="/tienda" data-testid="bottomnav-store" className={itemCls(pathname.startsWith("/tienda"))}>
        <Store className="w-5 h-5" /> Tienda
      </Link>
      <button data-testid="bottomnav-cart" onClick={() => setOpen(true)} className="relative -mt-6 grid place-items-center w-14 h-14 rounded-full bg-coral text-white card-shadow border-4 border-cream">
        <ShoppingBag className="w-6 h-6" />
        {count > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-5 h-5 px-1 grid place-items-center rounded-full bg-teal text-charcoal text-[11px] font-bold">{count}</span>
        )}
      </button>
      <Link to="/blog" data-testid="bottomnav-blog" className={itemCls(pathname.startsWith("/blog"))}>
        <Newspaper className="w-5 h-5" /> Blog
      </Link>
      <Link to="/nosotros" data-testid="bottomnav-about" className={itemCls(pathname === "/nosotros")}>
        <span className="text-lg leading-none">🐾</span> Nosotros
      </Link>
    </nav>
  );
};
